import React, { useCallback } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { Button } from 'ui-components/components/button';
import { DELIVERED_VIEW_ID } from '../../components/shipping-grid/views/view-id-constants';

const messages = defineMessages({
  title: {
    description: 'returnsPlaceholder.title',
    defaultMessage: 'You have no {statusView} to view',
    id: 'mtZyN5',
  },
  description: {
    description: 'returnsPlaceholder.description',
    defaultMessage:
      'Manage your Return Labels from this view. Track your returns by marking them as received when you get your product back, or request a refund by voiding your unused return labels.',
    id: 'E8jJU9',
  },
  buttonContent: {
    description: 'returnsPlaceholder.buttonContent',
    defaultMessage: 'Shipments > Delivered',
    id: 'QHCyjJ',
  },
  actionDescription: {
    description: 'returnsPlaceholder.actionDescription',
    defaultMessage: 'Create a return label for an existing shipment within {link}',
    id: 'Oq7DnZ',
  },
  boldStatusView: {
    description: 'returnsPlaceholder.boldStatusView',
    defaultMessage: 'Returns',
    id: 'j9fEuM',
  },
  link: {
    description: 'returnsPlaceholder.link',
    defaultMessage: 'Shipments > Delivered',
    id: 'xxsMtN',
  },
});

export const ReturnsPlaceholder = () => {
  const history = useHistory();

  const action = useCallback(() => {
    history.push(`/shipments/${DELIVERED_VIEW_ID}`);
  }, [history]);

  return (
    <ActionablePlaceholder
      action={action}
      actionDescription={
        <FormattedMessage
          {...messages.actionDescription}
          values={{
            link: (
              <Button onClick={action} theme='link'>
                <FormattedMessage {...messages.link} />
              </Button>
            ),
          }}
        />
      }
      buttonContent={<FormattedMessage {...messages.buttonContent} />}
      description={<FormattedMessage {...messages.description} />}
      title={
        <FormattedMessage
          {...messages.title}
          values={{
            statusView: (
              <b>
                <FormattedMessage {...messages.boldStatusView} />
              </b>
            ),
          }}
        />
      }
    />
  );
};
